import { useState } from 'react';

/**
 * 通用用户头像组件
 * 统一处理图片加载失败的兜底：未设置头像或图片加载失败时，
 * 显示默认头像（绿色底 + 昵称首字母）。
 * 默认头像样式统一在此组件内维护，后续调整只需修改这一处。
 *
 * @param {string} src   头像图片 URL，为空时直接显示默认头像
 * @param {string} name  用户昵称/用户名，用于兜底时展示首字母
 * @param {number} size  尺寸（px），默认 32
 * @param {number} radius 圆角（px），默认 6
 * @param {string} className 追加的样式类
 */
export default function Avatar({ src, name = '', size = 32, radius = 6, className = '' }) {
  const [failed, setFailed] = useState(false);
  const boxStyle = { width: size, height: size, borderRadius: radius };
  const initial = (name || '?').charAt(0).toUpperCase();

  // 图片存在且未加载失败时显示图片，否则显示默认头像
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        style={boxStyle}
        className={`object-cover flex-shrink-0 ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      style={boxStyle}
      className={`bg-green-600 flex items-center justify-center text-white font-semibold flex-shrink-0 ${className}`}
    >
      <span style={{ fontSize: Math.round(size * 0.45), lineHeight: 1 }}>{initial}</span>
    </div>
  );
}
